import { PersonsMembershipsDTO } from "../dto/PersonsMembershipsDTO";
import { Membership } from "../models/Person/Membership";

export const membershipMapper = (
  membership: PersonsMembershipsDTO,
): Membership => {
  const membershipType: any =
    "membershipType" in membership && membership.membershipType;

  return new Membership({
    price: membership.price || null,
    purchaseDate: membership.purchaseDate || null,
    startDate: membership.startDate || null,
    expirationDate: membership.expirationDate || null,
    type: membershipType.membershipTypeName || null,
    program: membershipType.programId || null,
    voided: membership.voidCloseId ? true : false,
    dto: membership,
    guestPrivileges: !!membership.guestPriv,
  });
};
